import { render, staticRenderFns } from "./page-footer-btn.vue?vue&type=template&id=24469002&scoped=true&"
import script from "./page-footer-btn.vue?vue&type=script&lang=js&"
export * from "./page-footer-btn.vue?vue&type=script&lang=js&"
import style0 from "./page-footer-btn.vue?vue&type=style&index=0&id=24469002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24469002",
  null
  
)

export default component.exports